import React, { useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

const WeeklyInputForm = ({ user }) => {
  const [formData, setFormData] = useState({
    weeklySessions: '',
    sessionsAttended: '',
    newClients: '',
    earlyDropoffs: '',
    notesPending: '',
    inquiries: '',
    referralsOut: '',
    inquiriesBooked: '',
  });
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const weekId = new Date().toISOString().split('T')[0];
      const userId = user?.uid || 'unknown_user';
      const docRef = doc(db, 'weeklyData', `${userId}_${weekId}`);

      const churnRate = Number(formData.newClients) > 0
        ? (Number(formData.earlyDropoffs) / Number(formData.newClients)).toFixed(2)
        : '0';

      await setDoc(docRef, {
        ...formData,
        churnRate,
        submittedAt: new Date().toISOString(),
      });

      setMessage('✅ Submission successful');
    } catch (err) {
      console.error('Submission error:', err);
      setMessage('❌ Submission failed');
    }
  };

  return (
    <div className="bg-white p-4 rounded shadow mt-4">
      <h2 className="text-lg font-bold mb-2">📥 Weekly Metrics Input</h2>
      <form onSubmit={handleSubmit} className="space-y-2">
        {Object.keys(formData).map((key) => (
          <input
            key={key}
            name={key}
            placeholder={key}
            value={formData[key]}
            onChange={handleChange}
            className="border p-1 w-full"
          />
        ))}
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
          Submit
        </button>
      </form>
      {message && <p className="mt-2 text-sm whitespace-pre-wrap">{message}</p>}
    </div>
  );
};

export default WeeklyInputForm;
